import ErrorHandler from '~/utils/api/errorHandler/ErrorHandler'

export default class FatalErrorHandler extends ErrorHandler {
  check (..._params: any[]) {
    this.store.dispatch('general/redirectFatal')
  }
}
